// removed by extract-text-webpack-plugin
module.exports = {"shadowed":"src-components----header-module---shadowed---2AK5I","logo":"src-components----header-module---logo---3gu8x","split_container":"src-components----header-module---split_container---3i38a","left_container":"src-components----header-module---left_container---2ph48","right_container":"src-components----header-module---right_container---gjJtC","grid_item":"src-components----header-module---grid_item---1noyT","align_right":"src-components----header-module---align_right---sbixP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header.module.css
// module id = 111
// module chunks = 114276838955818 162898551421021